import type { ReleaseTimeType } from '../../..';
import type { CalculationResult } from '../../../derived-state/CalculationResult';
import type { ShortCircuitProperty } from '../../../derived-state/gridElementsDetailsByCalculationType/shortCircuit/ShortCircuitProperty';
import type { ElectricCurrentType } from '../../../domain/ElectricCurrent';
import { ReleaseTime } from '../../../domain/ReleaseTime';
import type { EvaluatedResult } from '../../EvaluatedResult';
import type { ForShortCircuitEvaluation } from '../engines/ForShortCircuitEvaluation';

export function evaluateFaultCurrent(
  evaluatedProperty: ShortCircuitProperty,
  evaluate: ForShortCircuitEvaluation
): CalculationResult<EvaluatedResult<ElectricCurrentType>> {
  if (!evaluatedProperty.faultCurrent.toAmperes()) {
    return { type: 'CALCULATION_RESULT_NOT_AVAILABLE' };
  }

  return {
    type: 'CALCULATION_RESULT_AVAILABLE',
    result: evaluate(evaluatedProperty)
  };
}

export function evaluateProtectingReleaseTime(
  releaseTime: ReleaseTimeType | undefined,
  isDisabled: boolean
): CalculationResult<EvaluatedResult<ReleaseTime>> {
  if (isDisabled) {
    return { type: 'CALCULATION_RESULT_HIDDEN' };
  }

  if (noResult()) {
    return { type: 'CALCULATION_RESULT_NOT_AVAILABLE' };
  }

  return {
    type: 'CALCULATION_RESULT_AVAILABLE',
    result: {
      value: ReleaseTime.create(
        releaseTime!.result!.value!,
        releaseTime!.result!.unit
      ),
      status: 'NO_ATTENTION_REQUIRED'
    }
  };

  function noResult() {
    return !releaseTime?.isSuccess || releaseTime?.result?.value == null;
  }
}
